<template>
  <div>
    <div class="container-fluid m-0 p-0">
      <div class="bgFotoFeiern">
        <div class="overlayHotel">
          <div class="row justify-content-center align-items-center text-center">
            <div class="col-xs-12 col-sm-12 col-md-10 col-lg-8 center">
              <h3 class="Header__title px-5">{{$t("TrauungimGrünen")}}</h3>
              <p class="Header__text">
                    {{ $t("SiewünschensicheinewunderschöneHochzeit") }}                     
              </p>
            </div>
          </div>
        </div>
      </div>
      

      <section>
        <div class="kachelContainer">
          <div class="card fe1">
            <div class="card-body kachel-body">
              <h5 class="card-title">{{$t("Trauung")}}</h5>
            </div>
            <div class="card-footer">
              {{$t("GebenSiesichInEinerRomantischenUmgebungDasJAWort")}}
            </div>
          </div>
          <div class="card fe2">
            <div class="card-body kachel-body">
              <h5 class="card-title">{{$t("Feiern")}}</h5>
            </div>
            <div class="card-footer">
              {{$t("KulinarischeHighlightsundfestlicheMenüsfürIhrenbesonderenTag")}}            </div>
          </div>
          <div class="card fe3">
            <div class="card-body kachel-body">
              <h5 class="card-title">{{$t("Übernachtung")}}</h5>
            </div>
            <div class="card-footer">
              {{$t("KomfortableÜbernachtungsmöglichkeitenfürSieundIhreGäste")}}
            </div>
          </div>
          <div class="card fe4">
            <div class="card-body kachel-body">
              <h5 class="card-title">{{$t("Standesamtzimmer")}}</h5>
            </div>
            <div class="card-footer">
              {{$t("OffizielleTrauungen")}}
            </div>
          </div>
        </div>
      </section>
      <section>
        <div class="row justify-content-center">
          <div class="col-xs-12 col-sm-12 col-md-10 col-lg-7 center">
            <h3 class="willkommen__title">
              <img
                src="../assets/Eheringe.png"
                alt="Freies WLAN"
                style="width: 64px; height: 74px"
              />
              {{$t("IhreTrauungUnterFreiemHimmel")}}
            </h3>
            <p class="willkommen__text">
              <!-- neuer Text -->
              {{$t("IhreTrauungunterfreiemHimmelText")}}
            </p>
          </div>
        </div>
      </section>
      <section>
        <div class="row justify-content-center">
          <div class="col-xs-12 col-sm-12 col-md-10 col-lg-7 center">
            <KarussellFeiern2 />
          </div>
        </div>
      </section>
      <section>
        <div class="row justify-content-center">
          <div class="col-xs-12 col-sm-12 col-md-10 col-lg-7 center">
            <h3 class="willkommen__title">
              <img
                src="../assets/torte.png"
                alt="Freies WLAN"
                style="width: 64px; height: 74px"
              />
              {{$t("KulinarikDieBegeistert")}}
            </h3>
            <p class="willkommen__text">
              {{$t("UnsereKücheverwöhntSiemiteinemindividuell")}}
            </p>
          </div>
        </div>
      </section>
      <section>
        <div class="row justify-content-center">
          <div class="col-xs-12 col-sm-12 col-md-10 col-lg-7 center">
            <KarussellFeiern3 />
          </div>
        </div>
      </section>

      <section>
        <div class="row justify-content-center">
          <div class="col-xs-12 col-sm-12 col-md-10 col-lg-7 center">
            <h3 class="willkommen__title">
              <img
                src="../assets/hotel.png"
                alt="Freies WLAN"
                style="width: 64px; height: 74px"
              />
              {{$t("FeiernÜbernachtenAnEinemOrt")}}
            </h3>
            <p class="willkommen__text">
              {{$t("IhreHochzeitsgesellschaftkanndenbesonderen")}}
            </p>
          </div>
        </div>
      </section>
      <section>
        <div class="row justify-content-center">
          <div class="col-xs-12 col-sm-12 col-md-10 col-lg-7 center">
            <KarussellFeiern4 />
          </div>
        </div>
      </section>
      <section>
        <div class="row justify-content-center">
          <div class="col-xs-12 col-sm-12 col-md-10 col-lg-7 center">
            <h3 class="willkommen__title">
              <img
                src="../assets/Standesamt2.png"
                alt="Freies WLAN"
                style="width: 64px; height: 74px"
              />
              {{$t("Unser hauseigenes Standesamtzimmer")}}
            </h3>
            <p class="willkommen__text">
              
            </p>
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="col-12 col-lg-3 willkommen__text center">{{ $t("StandesamtText1") }}</div>
          <div class="col-12 col-lg-3 willkommen__text center "> <img
                src="../assets/offer-standesamt.jpg"
                alt="Standesamt"
                class="rundeEcken"
              /></div>
          <div class="col-12 col-lg-3 willkommen__text center">{{ $t("StandesamtText2") }}</div>
        </div>
      </section>


      

      <section>
        <div class="row justify-content-center">
          <div class="col-xs-12 col-sm-12 col-md-10 col-lg-7 center">
            <h3 class="willkommen__title"><img
                src="../assets/trauung.png"
                alt="Freies WLAN"
                style="width: 64px; height: 74px"
              /> {{$t("Alles aus einer Hand")}}</h3>
            <p class="willkommen__text">
              {{ $t("Von der Dekoration über den Ablauf") }}
            </p>
          </div>
        </div>
      </section>
      <section>        
        <div class="row justify-content-center">
          <div class="col-xs-12 col-sm-12 col-md-10 col-lg-4 center pt-lg-5 ">

            <div class="container-fluid rundeEcken" style="background: #f3f3f3">
            <div class="row align-items-center justify-content-center pt-4">
              <!-- Text + Button -->
              <div class="col-lg-12 d-flex flex-column align-items-center text-center">                
                <p class="detail__text rundeEcken">               
                  <ul class="feiernUL">
                    <li>{{$t("Trauung im Grünen oder im Standesamtzimmer")}}</li>
                    <li>{{$t("Individuelle Hochzeitsplanung & -beratung")}}</li>
                    <li>{{$t("Festliche Menüs & Buffets")}}</li>
                    <li>{{$t("Hochzeitstorte aus unserer Konditorei")}}</li>
                    <li>{{$t("Getränkepauschalen & Weinbegleitung")}}</li>
                    <li>{{$t("Dekoration & Floristik")}}</li>
                  
                    <li>{{$t("Make-up & Hairstyling")}}</li>
                    <li>{{$t("Übernachtungsmöglichkeiten für Sie & Ihre Gäste")}}</li>
                  </ul>
                </p>
            </div>
          </div>
        </div>
        </div>
          <div class="col-xs-12 col-sm-12 col-md-10 col-lg-4 center pt-lg-5">
            <div class="container-fluid rundeEcken" style="background: #f3f3f3">
              <div class="row align-items-center justify-content-center">
                <!-- Text + Button -->
                <div class="col-lg-12 d-flex flex-column align-items-center text-center pt-4">                  
                  <p class="detail__text">               
                    <ul class="feiernUL">
                      <li>{{$t("Feierliche Dekoration der Räumlichkeiten")}}</li>
                      <li>{{$t("Individuelle Menü- und Getränkekarten")}}</li>
                      <li>{{$t("Liebevolle Betreuung der kleinen Gäste")}}</li>
                      <li>{{$t("Musikalische Untermalung & DJ-Service")}}</li>
                      <li>{{$t("Fotografie & Videografie")}}</li>
                      <li>{{$t("Hochzeitstauben und Feuerwerkern")}}</li>
                      <li>{{$t("Komfortable Übernachtungsmöglichkeiten")}}</li>
                      <li>{{$t("Kostenfreie Parkplätze")}}</li>
                    </ul>
                  </p>
              </div>
            </div>
          </div>
          </div>
        </div>
        <div class="row justify-content-center pt-3">
          <div class="col-xs-12 col-sm-12 col-md-10 col-lg-8 willkommen__text">
            {{$t("Wählen Sie zwischen ausgewählten Teilleistungen")}}
          </div>
        </div>
      </section>

        <div class="row justify-content-center">
    <div class="col-xs-12 col-sm-12 col-md-10 col-lg-7 center">

      <div class="video-container">
    <video
      controls
      muted
      loop
      playsinline
      class="video-hotel"
    >
      <source src="/videos/lasershow.mp4" type="video/mp4" />
      Dein Browser unterstützt kein Video.
    </video>

    <h4 class="mt-3 text-center">Lasershow Video</h4>
  </div>
    </div>
</div>
<section class="video-section">
  
</section>



      <section>
        <div class="container-fluid pb-5" style="background: #f3f3f3">
          <div class="row align-items-center justify-content-center">
            <!-- Text + Button -->
            <div
              class="willkommen__title2 py-5 col-lg-6 d-flex flex-column align-items-center text-center"
            >
              {{ $t("Terminanfrage") }}
            </div>
          </div>
          <!-- Name -->
          <div class="row align-items-center justify-content-center">
            <div class="col-12 col-lg-6">
              <div class="input-group mb-3">
                <span class="input-group-text mailtext" id="basic-addon1">{{$t("Name*:")}}</span>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Name"
                  v-model="mail.name"
                  v-bind:class="background.name"
                />
              </div>
            </div>
          </div>
          <!-- Email -->
          <div class="row align-items-center justify-content-center">
            <div class="col-12 col-lg-6">
              <div class="input-group mb-3">
                <span class="input-group-text mailtext" id="basic-addon1">{{$t("Email*:")}}</span>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Email"
                  v-model="mail.email"
                  v-bind:class="background.email"
                />
              </div>
              <p v-if="!isValidEmail && mail.email" class="text-danger">
                {{$t("Ungültige E-Mail-Adresse")}}
              </p>
            </div>
          </div>
          <!-- Telefon -->
          <div class="row align-items-center justify-content-center">
            <div class="col-12 col-lg-6">
              <div class="input-group mb-3">
                <span class="input-group-text mailtext" id="basic-addon1">{{$t("Telefon:")}}</span>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Telefon"
                  v-model="mail.telefon"
                />
              </div>
            </div>
          </div>
          <!-- DAtum -->
          <div class="row align-items-center justify-content-center">
            <div class="col-12 col-lg-3">
              <div class="input-group mb-3">
                <span class="input-group-text mailtext" id="basic-addon1">{{$t("Datum:")}}*</span>
                <input
                  type="date"
                  class="form-control"
                  placeholder="Datum"
                  v-bind:class="background.datum"
                  v-model="mail.datum"
                />
              </div>
            </div>
            <div class="col-12 col-lg-3">
              <div class="input-group mb-3">
                <input
                  type="number"
                  class="form-control mailnumber"
                  placeholder="Anzahl Personen"
                  v-model="mail.personen"
                  min="1"
                />
                <span class="input-group-text mailnumberText" id="basic-addon1"
                  >{{$t("Anzahl Personen:")}}</span
                >
              </div>
            </div>
          </div>

          <div class="row align-items-center justify-content-center">
            <div class="col-12 col-lg-6">
              <div class="mb-3">
                <label for="exampleFormControlTextarea1" class="form-label"
                  >{{$t("Nachricht:")}}</label
                >
                <textarea
                  class="form-control"
                  id="exampleFormControlTextarea1"
                  rows="3"
                  v-model="mail.message"
                ></textarea>
              </div>
            </div>
          </div>
          <div class="row align-items-center justify-content-center mb-5">
            <div class="col-12 col-lg-6">
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  v-model="mail.datenschutz"
                  v-bind:class="background.datenschutz"
                  id="flexCheckDefault"
                />
                <label class="form-check-label" for="flexCheckDefault">
                  * {{ $t("Die Angaben zum") }}
                  <router-link to="/Datenschutz" class="">{{
                    $t("Datenschutz")
                  }}</router-link>
                  {{ $t("habe ich gelesen .") }}
                </label>
              </div>
            </div>
          </div>
          <div class="row align-items-center justify-content-center mb-5">
            <div class="col-12 col-lg-6">
              <button type="button" class="btn btn-primary" @click="sendMail()">
                {{$t("Anfragesenden")}}
              </button>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              {{ mail.gesendet }}
            </div>
          </div>
        </div>
      </section>
       <!-- Gästeempfehlungen -->
      <section>
        <div class="row justify-content-center">
          <div class="col-xs-12 col-sm-12 col-md-10 col-lg-7 center">
            <h3 class="willkommen__title">{{$t("Gästeempfehlenunsweiter")}}</h3>
            <p class="willkommen__text">
             {{$t("GästeempfehlenunsweiterText")}} 
            </p>
            <h4 class="textcenter">
              “{{$t("Gästeempfehlung4")}}”
            </h4>
            <h6 class="textcenter">{{$t("GästeempfehlungGast4")}}</h6>
            <h4 class="textcenter">“{{$t("Gästeempfehlung5")}}”</h4>
            <h6 class="textcenter">{{$t("GästeempfehlungGast5")}}</h6>
            <h4 class="textcenter">
              “{{$t("Gästeempfehlung6")}}”
            </h4>
            <h6 class="textcenter">{{$t("GästeempfehlungGast6")}}</h6>
          </div>
        </div>
      </section>
    </div>
    <stickybarTelMail />
  </div>
  <stickyPfeil />
</template>

<script>
//import carouselHeader from "../components/carouselHeader.vue";
import axios from "axios";
import stickybarTelMail from "../components/stickybarTelMail.vue";
import stickyPfeil from "../components/stickyPfeil.vue";
import KarussellFeiern2 from "@/components/KarussellFeiern2.vue";
import KarussellFeiern3 from "@/components/KarussellFeiern3.vue";
import KarussellFeiern4 from "@/components/KarussellFeiern4.vue";
export default {
  name: "MainPage",

  data() {
    return {
      windowHeight: window.innerHeight,
      windowWidth: window.innerWidth,
      newSite: null,
      mail: {
        name: "",
        email: "",
        message: "",
        telefon: "",
        personen: 0,
        datum: "",
        uhrzeit: "",
        datenschutz: false,
        gesendet: "",
      },
      background: {
        name: "",
        email: "",
        message: "",
        datenschutz: "",
      },
    };
  },
  components: {
    stickybarTelMail,
    stickyPfeil,
    KarussellFeiern2,
    KarussellFeiern3,
    KarussellFeiern4,
  },
  methods: {
    checkEingaben() {
      let re = true;
      if (this.mail.name == "") {
        this.background.name = "border border-2 border-danger";
        re = false;
      } else {
        this.background.name = "border border-2 border-success";
      }
      if (this.mail.email == "") {
        this.background.email = "border border-2 border-danger";
        re = false;
      } else {
        this.background.email = "border border-2 border-success";
      }
      if (this.mail.datum == "") {
        this.background.datum = "border border-2 border-danger";
        re = false;
      } else {
        this.background.datum = "border border-2 border-success";
      }
      if (this.mail.datenschutz == false) {
        this.background.datenschutz = "bg-danger";
        re = false;
      } else {
        this.background.datenschutz = "bg-success";
      }

      return re;
    },
    sendMail() {
      if (this.checkEingaben()) {
        const axiosConfig = {
          headers: {
            Accept: "text/plain",
            "Content-Type": "text/plain",
          },
        };
        const payload = {
         // empfaenger: "joerg@pillar.de",
          empfaenger: "info@weinhaus-eberitzsch.de",
          Name: this.mail.name,
          Email: this.mail.email,
          Telefon: this.mail.telefon,
          Text: this.mail.message,
          Doppelzimmer: this.mail.doppelzimmer,
          Einzelzimmer: this.mail.einzelzimmer,
          Familienzimmer: this.mail.familienzimmer,
          Hochzeitssuite: this.mail.hochzeitssuite,
          Appartements: this.mail.appartements,
          Von: this.mail.von,
          Bis: this.mail.bis,

          Datenschutz: this.mail.datenschutz,
        };
        let mail = this.mail;
        let background = this.background;
        axios
          .post("https://pillar.de/mailrelay/post_attachment.php", payload, axiosConfig)
          .then((response) => {
            console.log("success", response.data);
            mail.gesendet = "Ihre Anfrage wurden erfolgreich versendet";
            mail.name = "";
            background.name = "";
            mail.email = "";
            background.email = "";
            mail.message = "";
            background.message = "";
            mail.datenschutz = false;
            background.datenschutz = "";
            mail.telefon = "";
            background.telefon = "";
            mail.doppelzimmer = 0;
            mail.einzelzimmer = 0;
            mail.familienzimmer = 0;
            mail.hochzeitssuite = 0;
            mail.appartements = 0;
            mail.von = "";
            mail.bis = "";
          })
          .catch((error) => {
            console.log(error.response);
            mail.gesendet =
              "Ihre Kontaktdaten konnten leider nicht gesendet werden. Bitte rufen Sie uns an.";
          });
      }
    },
  },
  computed: {
    isValidEmail() {
      const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return regex.test(this.mail.email);
    },
  },
  mounted() {
    window.onresize = () => {
      this.windowHeight = window.innerHeight;
    };
  },
};
</script>

<style scoped></style>
